<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome da criança"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :item-class="getRowColor"
          :items="indexedItems"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:header.cfcp="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Número identificador do cidadão no e-SUS. Na falta dessa informação, atualizar o cadastro FCI ou Cidadão."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.nu_cpf="{ item }">
            <show-hide-field :value="item.nu_cpf"></show-hide-field>
          </template>

          <template v-slot:item.cfcp="{ item }">
            <div v-if="item.cfcp == null">
              <i class="icofont-warning"></i>
            </div>
            <div v-else>
              {{ item.cfcp }}
            </div>
          </template>
          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }} ({{
              item.idade_meses > 24
                ? `${item.idade_anos} anos`
                : `${item.idade_meses} ${
                    item.idade_meses == 0 || item.idade_meses == 1
                      ? 'mês'
                      : 'meses'
                  }`
            }})
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="8">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>Cadastrado por</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ item.nu_cpf }}
                    </td>
                    <td>
                      {{ item.nu_cns }}
                    </td>
                    <td>
                      {{ item.no_profissional }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <item-doses
                title="COVID 19"
                :doses="item.coresCovid19"
                tag="covid19"
                :item="item"
              >
              </item-doses>
              <item-doses title="BCG" :doses="item.coresBcg" :item="item">
              </item-doses>
              <item-doses
                title="Hepatite B"
                :doses="item.coresHepatiteB"
                :item="item"
              >
              </item-doses>
              <item-doses
                title="Pentavalente"
                :doses="item.coresPenta"
                :item="item"
              >
              </item-doses>
              <item-doses title="DTP" :doses="item.coresDtp" :item="item">
              </item-doses>
              <item-doses title="VIP" :doses="item.coresVip" :item="item">
              </item-doses>
              <item-doses
                title="Pneumocócica 10V (conjugada)"
                :doses="item.coresPneumococica"
                :item="item"
              >
              </item-doses>
              <item-doses
                title="Rotavírus Humano"
                :doses="item.coresRotaVirus"
                :item="item"
              >
              </item-doses>
              <item-doses
                title="Meningocócica C (conjugada)"
                :doses="item.coresMeningococicaC"
                :item="item"
              >
              </item-doses>
              <item-doses
                title="Febre Amarela"
                :doses="item.coresFebreAmarela"
                :item="item"
              >
              </item-doses>
              <item-doses
                title="Hepatite A"
                :doses="item.coresHepatiteA"
                :item="item"
              >
              </item-doses>
              <item-doses
                title="Tríplice Viral"
                :doses="item.coresTripliceViral"
                :item="item"
              >
              </item-doses>
              <item-doses
                title="Tetra Viral"
                :doses="item.coresTetraViral"
                :item="item"
              >
              </item-doses>
              <item-doses
                title="Varicela"
                :doses="item.coresVaricela"
                :item="item"
              >
              </item-doses>
              <item-doses title="HPV" :doses="item.coresHpv" :item="item">
              </item-doses>
              <item-doses
                title="Dupla Adulto"
                :doses="item.coresDuplaAdulto"
                :item="item"
              >
              </item-doses>
              <item-doses title="ACWY" :doses="item.coresAcwy" :item="item">
              </item-doses>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ItemDoses from './ItemDoses.vue'
import ShowHideField from '@/components/utils/ShowHideField.vue'

export default {
  name: 'TabelaCadastros',
  components: {
    ItemDoses,
    ShowHideField,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'MA',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  computed: {
    indexedItems() {
      return Functions.formatarCadastrosComDoses(this.cadastros)
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     */
    getRowColor(item) {
      if (
        item.coresCovid19.find((element) => element.cor === 'red') ||
        item.coresPenta.find((element) => element.cor === 'red') ||
        item.coresVip.find((element) => element.cor === 'red') ||
        item.coresDtp.find((element) => element.cor === 'red') ||
        item.coresBcg.find((element) => element.cor === 'red') ||
        item.coresHepatiteB.find((element) => element.cor === 'red') ||
        item.coresPneumococica.find((element) => element.cor === 'red') ||
        item.coresRotaVirus.find((element) => element.cor === 'red') ||
        item.coresMeningococicaC.find((element) => element.cor === 'red') ||
        item.coresFebreAmarela.find((element) => element.cor === 'red') ||
        item.coresHepatiteA.find((element) => element.cor === 'red') ||
        item.coresTripliceViral.find((element) => element.cor === 'red') ||
        item.coresTetraViral.find((element) => element.cor === 'red') ||
        item.coresVaricela.find((element) => element.cor === 'red') ||
        item.coresHpv.find((element) => element.cor === 'red') ||
        item.coresAcwy.find((element) => element.cor === 'red') ||
        item.coresDuplaAdulto.find((element) => element.cor === 'red')
      ) {
        return `table-row-color-red`
      } else {
        return `table-row-color-green`
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
